import { hyphenate } from './stringFormatter';
var msPattern = /^ms-/;
export default (function (string) {
  return hyphenate(string).replace(msPattern, '-ms-');
});